import React from "react";
import PublicFooter from "../components/PublicFooter";

export default function PrivacyPolicy() {
  return (
    <div className="container py-5">
      <h1>Privacybeleid</h1>

      <p>Laatst bijgewerkt: 03/06/2026</p>

      <p>
        DR Rentals is een handelsnaam van Cedric Coudijzer, geregistreerd onder
        ondernemingsnummer BE 0720.658.431.
      </p>

      <h2>1. Identiteit van de verwerkingsverantwoordelijke</h2>
      <p>
        DR Rentals<br />
        Handelsnaam van Cedric Coudijzer<br />
        Ondernemingsnummer: BE 0720.658.431<br />
        E-mail: info@dr-rentals.be<br />
        Telefoon: 0479 65 88 28
      </p>

      <h2>2. Welke persoonsgegevens verzamelen wij?</h2>
      <p>
        Wanneer u gebruik maakt van onze website of een reservatie maakt,
        kunnen wij de volgende persoonsgegevens verzamelen:
      </p>

      <ul>
        <li>Naam en voornaam</li>
        <li>Adres</li>
        <li>E-mailadres</li>
        <li>Telefoonnummer</li>
        <li>Geboortedatum</li>
        <li>Rijksregisternummer (indien wettelijk noodzakelijk)</li>
        <li>Kopie van identiteitskaart</li>
        <li>Kopie van rijbewijs</li>
        <li>Nummerplaatgegevens van het trekkend voertuig</li>
        <li>Reservatie- en verhuurgegevens</li>
        <li>Communicatie via contactformulieren of e-mail</li>
      </ul>

      <h2>3. Waarom verwerken wij uw gegevens?</h2>
      <p>Wij verwerken persoonsgegevens voor de volgende doeleinden:</p>

      <ul>
        <li>Het verwerken en beheren van reservaties.</li>
        <li>Het opstellen en uitvoeren van huurovereenkomsten.</li>
        <li>Identiteits- en rijbewijscontrole.</li>
        <li>Facturatie en administratie.</li>
        <li>Klantenondersteuning.</li>
        <li>Het voorkomen van fraude en misbruik.</li>
        <li>Het naleven van wettelijke verplichtingen.</li>
      </ul>

      <h2>4. Rechtsgrond van de verwerking</h2>
      <p>
        Wij verwerken uw persoonsgegevens op basis van:
      </p>

      <ul>
        <li>De uitvoering van een overeenkomst.</li>
        <li>Wettelijke verplichtingen.</li>
        <li>Ons gerechtvaardigd belang om onze diensten veilig aan te bieden.</li>
        <li>Uw toestemming indien vereist.</li>
      </ul>

      <h2>5. Bewaartermijn</h2>
      <p>
        Persoonsgegevens worden niet langer bewaard dan noodzakelijk voor de
        doeleinden waarvoor zij zijn verzameld.
      </p>

      <ul>
        <li>Reservatie- en klantgegevens: maximaal 10 jaar.</li>
        <li>Facturatiegegevens: volgens de wettelijke bewaartermijn.</li>
        <li>Contactaanvragen: maximaal 2 jaar.</li>
        <li>Identiteits- en rijbewijsdocumenten: maximaal 30 dagen na afloop van de huurperiode, tenzij wettelijke verplichtingen anders bepalen.</li>
      </ul>

      <h2>6. Delen van persoonsgegevens</h2>
      <p>
        Wij verkopen uw persoonsgegevens nooit aan derden.
        Gegevens kunnen uitsluitend worden gedeeld met:
      </p>

      <ul>
        <li>Boekhoudkundige en administratieve dienstverleners.</li>
        <li>IT- en hostingpartners.</li>
        <li>Overheidsinstanties wanneer wettelijk verplicht.</li>
        <li>Verzekeringsmaatschappijen bij schadegevallen.</li>
      </ul>

      <h2>7. Beveiliging van gegevens</h2>
      <p>
        Wij nemen passende technische en organisatorische maatregelen om uw
        persoonsgegevens te beschermen tegen verlies, misbruik of ongeoorloofde toegang.
      </p>

      <h2>8. Cookies</h2>
      <p>
        Onze website kan gebruik maken van cookies om de werking van de website
        te verbeteren en bezoekersstatistieken te verzamelen.
      </p>

      <h2>9. Uw rechten</h2>
      <p>
        U heeft het recht om:
      </p>

      <ul>
        <li>Uw persoonsgegevens in te kijken.</li>
        <li>Uw gegevens te laten corrigeren.</li>
        <li>Uw gegevens te laten verwijderen wanneer wettelijk mogelijk.</li>
        <li>De verwerking te beperken.</li>
        <li>Bezwaar te maken tegen bepaalde verwerkingen.</li>
        <li>Uw gegevens over te dragen.</li>
      </ul>

      <p>
        Verzoeken kunnen worden gericht aan:
        <br />
        info@dr-rentals.be
      </p>

      <h2>10. Klachten</h2>
      <p>
        Indien u meent dat uw persoonsgegevens onrechtmatig worden verwerkt,
        kunt u een klacht indienen bij de Belgische Gegevensbeschermingsautoriteit.
      </p>

      <p>
        Gegevensbeschermingsautoriteit (GBA)<br />
        Drukpersstraat 35<br />
        1000 Brussel<br />
        Website: www.gegevensbeschermingsautoriteit.be
      </p>

      <h2>11. Wijzigingen</h2>
      <p>
        DR Rentals behoudt zich het recht voor dit privacybeleid op elk moment
        aan te passen. De meest recente versie wordt steeds op deze website gepubliceerd.
      </p>
      <PublicFooter />
    </div>
  );
}
